// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"3d0cb75a","453":"5cc15ead","704":"9548227b"}[chunkId] + ".chunk.js";
};